import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { format, parseISO } from "date-fns";
import { MapPin, CalendarBlank, Clock } from "@phosphor-icons/react";

const EventCard = ({ event, index = 0 }) => {
  const dt = typeof event.date_time === "string" ? parseISO(event.date_time) : new Date(event.date_time);

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.08 }}
      className="group bg-[#111111] border border-[#2A2A2A] hover:border-[#e2a9f1]/40 transition-all duration-500 hover:-translate-y-0.5"
      data-testid={`event-card-${event.id}`}
    >
      <Link to={`/events/${event.id}`} data-testid={`event-card-link-${event.id}`}>
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={event.image_url || "https://images.unsplash.com/photo-1500217052183-bc01eee1a74e?crop=entropy&cs=srgb&fm=jpg&q=85"}
            alt={event.title}
            className="absolute inset-0 w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/50 to-transparent" />
          <div className="absolute top-4 left-4 font-mono-overline text-[#e2a9f1]">
            {event.city}
          </div>
          {event.event_type === "spicy" && (
            <div
              data-testid={`event-spicy-badge-${event.id}`}
              className="absolute top-4 right-4 font-mono-overline text-[10px] text-[#0A0A0A] bg-[#e2a9f1] px-2 py-1"
            >
              Spicy · Play
            </div>
          )}
        </div>
        <div className="p-6 md:p-8">
          <h3 className="text-2xl md:text-3xl font-serif-display text-[#EDEDED] mb-3 leading-tight">
            {event.title}
          </h3>
          <div className="space-y-2 text-sm text-[#A3A3A3] mb-6">
            <div className="flex items-center gap-2">
              <CalendarBlank size={16} weight="thin" className="text-[#e2a9f1]" />
              {format(dt, "EEEE, d MMMM yyyy")}
            </div>
            <div className="flex items-center gap-2">
              <Clock size={16} weight="thin" className="text-[#e2a9f1]" />
              {format(dt, "h:mm a")}
            </div>
            <div className="flex items-center gap-2">
              <MapPin size={16} weight="thin" className="text-[#e2a9f1]" />
              {event.venue}
            </div>
          </div>
          <div className="flex items-end justify-between pt-4 border-t border-[#2A2A2A]">
            <div className="space-y-0.5">
              <div className="flex items-baseline gap-2">
                <span className="font-mono-overline text-[#A3A3A3]">Couples</span>
                <span className="text-xl font-serif-display text-[#e2a9f1]">£{Number(event.price_couple).toFixed(0)}</span>
              </div>
              <div className="flex items-baseline gap-2">
                <span className="font-mono-overline text-[#A3A3A3]">Single Ladies</span>
                <span className="text-base font-serif-display text-[#e2a9f1]">£{Number(event.price_single_lady).toFixed(0)}</span>
              </div>
            </div>
            <span
              data-testid={`event-card-view-${event.id}`}
              className="font-mono-overline text-[#EDEDED] group-hover:text-[#e2a9f1] transition-colors"
            >
              View →
            </span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default EventCard;
